'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _components = require('../../components');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _routerAdapter = require('../../helpers/routerAdapter');
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _staff = require('../../redux/modules/staff');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var









RealtorUserPage = function (_Component) {_inherits(RealtorUserPage, _Component);function RealtorUserPage() {var _temp, _this, _ret;_classCallCheck(this, RealtorUserPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.





















    parseIdFromRoute = function () {var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var idPart = route.split('/').pop();
      return idPart.includes('pid') ? idPart.split('pid_').pop() : '';
    }, _this.

    checkPopupIsOpen = function (routeData) {
      if (routeData && (routeData.pid || routeData.route.includes('pid'))) {
        var id = routeData.pid || _this.parseIdFromRoute(routeData.route);
        setTimeout(function () {return _this.openDetailsPopup(id);}, 1000);
      }
    }, _this.

    openDetailsPopup = function (propertyId) {return _this.props.openDetailsPopup({ propertyId: propertyId });}, _temp), _possibleConstructorReturn(_this, _ret);}RealtorUserPage.prototype.componentDidMount = function componentDidMount() {var _this2 = this;if (this.props.routeData && this.props.routeData.optionType) {this.props.loadStaff(this.props.routeData.optionType);this.props.loadCompanyProps(this.props.routeData.optionType);}this.checkPopupIsOpen(this.props.routeData);this.unlistenRouteChange = _reactRouter.browserHistory.listen(function (_ref) {var action = _ref.action,pathname = _ref.pathname;if (action === 'POP') {var propertyId = _this2.parseIdFromRoute(pathname);if (!!propertyId) {_this2.openDetailsPopup(propertyId);}}});};RealtorUserPage.prototype.componentWillUnmount = function componentWillUnmount() {this.unlistenRouteChange();};RealtorUserPage.prototype.

  render = function render() {var _props =









    this.props,isNative = _props.isNative,_props$staff = _props.staff,translatedDescriptionRequired = _props$staff.translatedDescriptionRequired,descriptionLoaded = _props$staff.descriptionLoaded,translatedDescriptionText = _props$staff.translatedDescriptionText,showOriginalDescription = _props$staff.showOriginalDescription,descriptionLoading = _props$staff.descriptionLoading;

    var descriptionData = {
      translatedRequired: translatedDescriptionRequired,
      loaded: descriptionLoaded,
      translatedText: translatedDescriptionText,
      showOriginal: showOriginalDescription,
      loading: descriptionLoading };


    return this.props.isLoaded ?
    _react2.default.createElement(_components.RealtorUser, _extends({},
    this.props, {
      isNative: isNative,
      descriptionData: descriptionData })) :


    _react2.default.createElement('div', null,
      _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }));


  };return RealtorUserPage;}(_react.Component);


RealtorUserPage.propTypes = {
  locale: _propTypes2.default.string,
  error: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  location: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  isLoaded: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  properties: _propTypes2.default.array,
  staffData: _propTypes2.default.object,
  staff: _propTypes2.default.object,
  loadCompanyProps: _propTypes2.default.func,
  loadStaff: _propTypes2.default.func,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(store) {
  var routeData = (0, _routerAdapter.extractRouteData)(store.routing, store.lang.locale);

  return {
    locale: routeData.locale,
    isRtl: (0, _checkRtlLanguage2.default)(store.lang.locale),
    routeData: routeData,
    isNative: store.native.isNative,
    isMobile: store.windowDimentions.isMobile,
    translate: (0, _reduxPagan.getLang)(store.lang, 'static'),
    staffData: store.staff.data,
    staff: store.staff,
    isLoaded: store.staff.loaded,
    properties: store.staff.properties };

};

var mapDispatchToProps = {
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  loadCompanyProps: _staff.loadCompanyProps,
  translateDescription: _staff.translateDescription,
  resetTranslate: _staff.resetTranslate,
  detectDescriptionLanguage: _staff.detectDescriptionLanguage,
  toggleDescriptionTranslation: _staff.toggleDescriptionTranslation,
  loadStaff: _staff.loadStaff };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
RealtorUserPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/RealtorUserPage/RealtorUserPage.js
// module id = 3126
// module chunks = 0